import { effect, signal, WritableSignal } from '@angular/core';


/**
 * La funcion **`useLocalStorageSignal<T>()`** guarda datos de diferentes 
 * tipos de datos en el local storage, y devuelve su valor en un signal.
 * @param key 
 * @param initialValue 
 * @returns WritableSignal<T>
 */
export function useLocalStorageSignal<T>(
  key: string,
  initialValue: T
): WritableSignal<T> {
  const stored = localStorage.getItem(key);

  const startValue = stored ? JSON.parse(stored) : initialValue;

  const signalValue = signal<T>(startValue);

  effect(() => {
    localStorage.setItem(key, JSON.stringify(signalValue()));
  });

  return signalValue;
}
